<img _ngcontent-pge-c105="" src="../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo">


<div class="iwg-form-dialog"
    [ngClass]="{'iwg-dialog-half-size': ( selectedStepIndex == 0 || selectedStepIndex == 3 || (selectedStepIndex == 1 && quoteView==null)||selectedStepIndex == 2|| (selectedStepIndex == 1 && quoteView.length==0))}">
    <div class="md-toolbar-tools d-flex md-theme m-0 p-3">
        <h2 class="m-0" class="toolbartitle">
            {{WizardTitle}}
        </h2>
        <span class="flex"></span>
        <span>Step {{selectedStepIndex + 1}} of {{numberOfSteps}}</span>
    </div>


    <mat-progress-bar color="accent" mode="indeterminate" *ngIf="isLoading" style="position: absolute">
    </mat-progress-bar>
    <mat-dialog-content style="overflow: auto;padding:0px;width: 100%;">
        <div class="vista-popup-height">
            <div class="d-flex layout-row" style="height: 100%;">
                <div class="d-flex layout-column flex md-padding w-100"
                    style="height:100%;overflow-y: scroll;box-sizing: border-box;padding: 16px;">
                    <mat-tab-group [(selectedIndex)]="selectedStepIndex" class="header-less-tabs">
                        <mat-tab label="Step 1">
                            <h3 class="mat-header">{{AssignmentLabel}} </h3>
                            <form [formGroup]="FormDataStep1">
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Quote Title</mat-label>
                                        <input type="text" class="p-input" matInput formControlName="title" name="title" id="title" maxlength="200" required
                                        [ngClass]="{ 'is-invalid': FormDataStep1.controls.title.errors }">
                                    </mat-form-field>
                                    <mat-icon
                                        matTooltip=" Provide a title with enough context to help you track the quote."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                    <mat-error *ngIf="!FormDataStep1.controls['title'].valid && FormDataStep1.controls['title']?.touched">Required</mat-error>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Client/Prospect</mat-label>
                                        <input matInput formControlName="client_name" name="client_name" maxlength="200"
                                            required  [ngClass]="{ 'is-invalid': FormDataStep1.controls.client_name.errors }">
                                    </mat-form-field>
                                    <mat-icon matTooltip="Enter the client for whom this quote will be presented."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>End Client</mat-label>
                                        <input matInput formControlName="end_client" name="end_client" maxlength="200"
                                            >
                                    </mat-form-field>
                                    <mat-icon matTooltip="Enter the end client for whom this quote will be presented."
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label [ngClass]="{ 'is-invalid': FormDataStep1.controls.commission_percent.touched && FormDataStep1.controls.commission_percent.value<0.25 }">1st Sales Executive Commission %</mat-label>
                                        <input matInput formControlName="commission_percent" name="commission_percent"
                                            type="number" min="0.25" step="0.25" required [ngClass]="{ 'is-invalid': FormDataStep1.controls.commission_percent.touched && FormDataStep1.controls.commission_percent.value<0.25 }">
                                    </mat-form-field>
                                    <mat-icon matTooltip="Enter the commission for the 1st sales executive."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>2nd Sales Exec</mat-label>
                                        <mat-select formControlName="secondary_sales_exec"
                                            (selectionChange)="onselectedQuoteChange($event)">
                                            <mat-option [value]="-1">
                                                None
                                            </mat-option> 
                                            <mat-option *ngFor="let item of salesOption" [value]="item">{{item.Name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-icon matTooltip="Please select the sales exec."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>2nd Sales Executive Commission %</mat-label>
                                        <input matInput formControlName="commission_percent_secondary"
                                            name="commission_percent" type="number" step="0.25">
                                    </mat-form-field>
                                    <mat-icon matTooltip="Enter the commission for the 2nd sales executive."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Notes </mat-label>
                                        <textarea matInput formControlName="notes" class="mat-textareafield" name="notes" rows="2" maxlength="200" style="height: 67px;"
                                            ></textarea>
                                    </mat-form-field>
                                    <mat-icon matTooltip="Enter any notes you'd like to appear relevent to this quote."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon> 
                                </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="Step 2">
                            <h3 class="mat-header">Add New Line</h3>
                            <form [formGroup]="FormDataStep2">
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>State</mat-label>
                                        <mat-select formControlName="new_state"
                                            (selectionChange)="onselectedQuoteChange($event)" required> 
                                            <mat-option [value]="-1">
                                                Please Select <sup class="mat-asterix">*</sup>
                                            </mat-option>
                                            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}
                                            </mat-option>
                                        </mat-select>

                                    </mat-form-field>
                                   
                                    <mat-icon matTooltip="Select the state to be quoted." matTooltipPosition="above"
                                        class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_workers.touched && FormDataStep2.controls.new_number_of_workers.value<1}">Number of Workers</mat-label>                                      
                                        <input matInput formControlName="new_number_of_workers"
                                            name="new_number_of_workers" type="number" min="1" required                                           
                                            [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_workers.touched && FormDataStep2.controls.new_number_of_workers.value<1}" > 
                                    </mat-form-field>
                                    <mat-icon matTooltip="Enter the number of workers." matTooltipPosition="above"
                                        class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                </div>
                                <div layout>
                                    <div class="md-input-container" fxFlex="100%" style="padding-left: 5px;">
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="30%">
                                            <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_8810.touched && FormDataStep2.controls.new_number_of_8810.value<0}">8810 Workers</mat-label>
                                            <input matInput formControlName="new_number_of_8810"
                                                name="new_number_of_8810" type="number" min="0" required [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_8810.touched && FormDataStep2.controls.new_number_of_8810.value<0}">
                                        </mat-form-field>
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="30%"
                                            style="padding-left: 5px;">
                                            <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_8810_plus.touched && FormDataStep2.controls.new_number_of_8810_plus.value<0}">8810+ Workers</mat-label>
                                            <input matInput formControlName="new_number_of_8810_plus"
                                                name="new_number_of_8810_plus" type="number" min="0" [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_8810_plus.touched && FormDataStep2.controls.new_number_of_8810_plus.value<0}">
                                        </mat-form-field>
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="30%"
                                            style="padding-left: 5px;">
                                            <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_8810_other.touched && FormDataStep2.controls.new_number_of_8810_other.value<0}">Other Workers</mat-label>
                                            <input matInput formControlName="new_number_of_8810_other"
                                                name="number_of_8810_other" type="number" min="0" [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_8810_other.touched && FormDataStep2.controls.new_number_of_8810_other.value<0}">
                                        </mat-form-field>
                                        <mat-icon matTooltip="Enter the distribution of workers based on 8810 status."
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                    </div>
                                </div>
                                <div layout>
                                    <div class="md-input-container" fxFlex="100%" style="padding-left: 5px;">
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="45%">
                                            <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_regular.touched && FormDataStep2.controls.new_number_of_regular.value<0}">Regular Workers</mat-label>
                                            <input matInput formControlName="new_number_of_regular"
                                                name="number_of_regular" type="number" min="0" required [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_regular.touched && FormDataStep2.controls.new_number_of_regular.value<0}">
                                        </mat-form-field>
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="45%"
                                            style="padding-left: 5px;">
                                            <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_sporadic.touched && FormDataStep2.controls.new_number_of_sporadic.value<0}">Sporadic Workers</mat-label>
                                            <input matInput formControlName="new_number_of_sporadic"
                                                name="new_number_of_sporadic" type="number" min="0" [ngClass]="{'is-invalid': FormDataStep2.controls.new_number_of_sporadic.touched && FormDataStep2.controls.new_number_of_sporadic.value<0}">
                                        </mat-form-field>
                                        <mat-icon
                                            matTooltip="A regular employee works on a usual and consistent basis. A sporadic employee works on an infrequent, irregular, or occurring in scattered instances and not on a regular weekly schedule."
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                    </div>
                                </div>
                                <div layout>
                                    <div class="md-input-container" fxFlex="100%" style="padding-left: 5px;">
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="40%">
                                            <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_hourly_rate.touched && FormDataStep2.controls.new_hourly_rate.value<0.01}" >Avg Hourly Pay Rate*</mat-label>
                                            <input matInput formControlName="new_hourly_rate" name="new_hourly_rate"
                                                type="number" min="0.01"  [ngClass]="{'is-invalid': FormDataStep2.controls.new_hourly_rate.touched && FormDataStep2.controls.new_hourly_rate.value<0.01}" >
                                        </mat-form-field>
                                        <mat-icon matTooltip="Enter the average hourly payrate." fxFlex="10%"
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="40%"
                                            style="padding-left: 5px;">
                                            <mat-label [ngClass]="{'is-invalid': FormDataStep2.controls.new_weekly_hours.touched && FormDataStep2.controls.new_weekly_hours.value<0.01}" >Avg Weekly Hours</mat-label>
                                            <input matInput formControlName="new_weekly_hours" name="new_weekly_hours"
                                                type="number" min="0.01" required [ngClass]="{'is-invalid': FormDataStep2.controls.new_weekly_hours.touched && FormDataStep2.controls.new_weekly_hours.value<0.01}" >
                                        </mat-form-field>
                                        <mat-icon fxFlex="10%"
                                            matTooltip="Enter average weekly hours worked each week. Note: If the worker is sporadic, enter the average of all hours worked over the number of weeks of the assignment."
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                    </div>
                                </div>
                                <div layout>
                                    <div class="md-input-container" fxFlex="100%" style="padding-left: 5px;">
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="40%" floatLabel="always">
                                            <mat-label>Start Date</mat-label>
                                            <input name="new_start_date" formControlName="new_start_date"
                                                placeholder="Select" matInput [matDatepicker]="start" required
                                                 [ngClass]="{'is-invalid': FormDataStep2.controls.new_start_date.errors}" >
                                            <mat-datepicker-toggle matSuffix [for]="start" class="dateToolge"></mat-datepicker-toggle>
                                            <mat-datepicker #start></mat-datepicker>
                                        </mat-form-field>
                                        <mat-icon matTooltip="Enter the start date" matTooltipPosition="above" fxFlex="10%"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                    
                                        <mat-form-field class="mat-form-withtooltip" fxFlex="40%" floatLabel="always">
                                            <mat-label>End Date</mat-label>
                                            <input name="new_end_date" formControlName="new_end_date"
                                                placeholder="Select" matInput [matDatepicker]="end" required [ngClass]="{'is-invalid': FormDataStep2.controls.new_end_date.errors}" >
                                            <mat-datepicker-toggle matSuffix [for]="end" class="dateToolge"></mat-datepicker-toggle>
                                            <mat-datepicker #end></mat-datepicker>
                                        </mat-form-field>
                                        <mat-icon matTooltip="Enter the end date" matTooltipPosition="above" fxFlex="10%"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                    </div>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Enter Any Notes:</mat-label>
                                        <textarea matInput formControlName="new_notes" class="mat-textareafield" name="new_notes" rows="2" maxlength="200" style="height: 54px;"></textarea>
                                    </mat-form-field>
                                    <mat-icon
                                        matTooltip="Enter any notes you'd like to appear relevent to this portion of the quote."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                </div>

                            </form>

                            <div layout="column" fxHide fxShow.lt-sm
                            *ngIf="selectedStepIndex == 1 && quoteView.length != 0 && quoteView != null">
        
                            <div class="iwg-widget-box-card" *ngIf="Quote && ((selectedStepIndex + 1)===2)"
                                style="overflow-y: scroll;">
                                <table>
                                    <tr>
                                        <td colspan="3">
                                            <h3 class="bold">Review Markup Details</h3>
                                        </td>
                                    </tr>
        
                                    <tr>
                                        <td style="width:300px;">
                                            <label class="iwg-regular-label"><b><u>Generated Pricing</u></b></label><br />
                                        </td>
                                        <td style="width:50px;"></td>
                                        <td style="width:500px;">
                                            <label class="iwg-regular-label"><b><u>Markup Override</u></b></label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">Markup: </label><input
                                                [(ngModel)]="QuoteOverridenMarkupNew" type="number" step="0.25"
                                                name="QuoteOverridenMarkup"> <br />
        
                                            <button style="margin: 10px 0px 5px 5px;" mat-button mat-raised-button
                                                color="primary" class="mat-primary mat-raised iwg-mat-raised"
                                                (click)="calculateMarkupOverride()">
                                                Recalculate
                                            </button>
        
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">Markup:
                                                {{QuoteMinimumMarkup * 100 | number: "1.2-2"}}%</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">Markup: {{QuoteOverridenMarkup}}%</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">Revenue:
                                                ${{QuoteMinimumRevenue | number: "1.2-2"}}</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">Revenue:
                                                ${{QuoteOverridenRevenue | number: "1.2-2"}}</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">Gross Profit:
                                                ${{QuoteMinimumGrossProfit | number: "1.2-2"}}</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">Gross Profit:
                                                ${{QuoteOverridenGrossProfit | number: "1.2-2"}}</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">Gross Profit %:
                                                {{(QuoteMinimumRevenue == 0)? 0 :100 * QuoteMinimumGrossProfit/QuoteMinimumRevenue | number: "1.2-2"}}%</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">Gross Profit %:
                                                {{(QuoteOverridenRevenue == 0)? 0 :100 * QuoteOverridenGrossProfit/QuoteOverridenRevenue | number: "1.2-2"}}%</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">1st Commission%:
                                                {{FormDataStep1.value.commission_percent  | number: "1.2-2"}}%</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">1st Commission%:
                                                {{FormDataStep1.value.commission_percent | number: "1.2-2"}}%</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">1st Commission:
                                                ${{QuoteMinimumSalesCommission | number: "1.2-2"}}</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">1st Commission:
                                                ${{QuoteOverridenSalesCommission | number: "1.2-2"}}</label><br />
                                        </td>
                                    </tr>
        
        
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">2nd Commission%:
                                                {{FormDataStep1.value.commission_percent_secondary  | number: "1.2-2"}}%</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">2nd Commission%:
                                                {{FormDataStep1.value.commission_percent_secondary | number: "1.2-2"}}%</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">2nd Commission:
                                                ${{QuoteMinimumSalesCommissionSecondary | number: "1.2-2"}}</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">2nd Commission:
                                                ${{QuoteOverridenSalesCommissionSecondary | number: "1.2-2"}}</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">Net Income:
                                                ${{QuoteMinimumProfit | number: "1.2-2"}}</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">Net Income:
                                                ${{QuoteOverridenProfit | number: "1.2-2"}}</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="iwg-regular-label">Return on Sales:
                                                {{QuoteMinimumReturnOnSales * 100 | number: "1.2-2"}}%</label><br />
                                        </td>
                                        <td></td>
                                        <td>
                                            <label class="iwg-regular-label">Return on Sales:
                                                {{QuoteOverridenReturnOnSales * 100 | number: "1.2-2"}}%</label><br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <h3 class="bold">Review Quote Line Items</h3>
                                        </td>
                                    </tr>
                                    <tbody *ngFor="let item of quoteView">
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label"><b><u>Entered</u></b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label"><b><u>Calculated</u></b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">State: <b>{{item.State}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">Markup:
                                                    {{item.Markup * 100 | number: "1.2-2" }}%</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Number Of Workers:
                                                    <b>{{item?.NumberOfWorkers}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">Revenue:
                                                    ${{item.Revenue | number: "1.2-2" }}</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">8810 Workers:
                                                    <b>{{item.NumberOf8810}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">Gross Profit:
                                                    ${{item.GrossProfit | number: "1.2-2" }}
                                                    ({{(item.Revenue == 0) ?  0 : 100 * item.GrossProfit/item.Revenue | number: "1.2-2" }}%)</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">8810-Plus Workers:
                                                    <b>{{item.NumberOf8810Plus}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">1st Commission:
                                                    ${{item.SalesCommission | number: "1.2-2" }}
                                                    ({{item.CommissionPercent * 100 | number: "1.2-2" }}%)</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Other Workers:
                                                    <b>{{item.NumberOf8810Other}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">2nd Commission:
                                                    ${{item.SalesCommissionSecondary | number: "1.2-2" }}
                                                    ({{item.CommissionPercentSecondary * 100 | number: "1.2-2" }}%)</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Regular Workers:
                                                    <b>{{item.NumberOfRegular}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">Net Income:
                                                    ${{item.Profit | number: "1.2-2" }}</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Sporadic Workers:
                                                    <b>{{item.NumberOfSporadic}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label"><label class="iwg-regular-label">Return on
                                                        Sales: {{item.ReturnOnSales * 100 | number: "1.2-2" }}%</label></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Hours Per Week:
                                                    <b>{{item.HoursPerWeek}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">SUTA:
                                                    <b>{{item.SUTAPercent* 100 | number: "1.2-2" }}%</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Hourly Payrate:
                                                    <b>${{item.HourlyPayrate | number: "1.2-2" }}/hr</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">FUTA:
                                                    <b>{{item.FUTAPercent * 100| number: "1.2-2" }}%</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Start Date:
                                                    <b>{{item.StartDate | date}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">FICA:
                                                    <b>{{item.FICAPercent * 100| number: "1.2-2" }}%</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">End Date:
                                                    <b>{{item.EndDate  | date}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">Medicare:
                                                    <b>{{item.MedicarePercent * 100| number: "1.2-2" }}%</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="iwg-regular-label">Notes: <b>{{item.Notes}}</b></label>
                                            </td>
                                            <td></td>
                                            <td>
                                                <label class="iwg-regular-label">Validation: <b
                                                        style="color:red">{{item.ValidationMessage}}</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <button style="margin-right: 10px;" mat-button mat-raised-button color="primary"
                                                    class="mat-primary mat-raised iwg-mat-raised"
                                                    (click)="editLineItem(item.ID,true)">
                                                    Edit
                                                </button>
                                                <button mat-button mat-raised-button color="primary"
                                                    class="mat-primary mat-raised iwg-mat-raised"
                                                    (click)="deleteLineItem(item.ID,false)">
                                                    Remove
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <hr />
                                            </td>
                                        </tr>
                                    </tbody>
        
                                </table>
                            </div>
                        </div>





                        </mat-tab>
                        <mat-tab label="Step 3">
                            <div class="pad-submit">
                            <h3 class="bold">Submit Quote For Approval?</h3>
                            <div layout="row">
                                This quote is valid for 30 days and is based on the accuracy of information provided in
                                the quote request.
                            </div>
                            <div layout="row">
                                &nbsp;
                            </div>
                            <div layout="row">
                                <!-- <a mat-button class="mat-primary mat-raised iwg-mat-raised"
                                    (click)="prevStep(); $event.preventDefault();" layout="row">
                                    Back
                                    <span flex></span>
                                    <mat-icon>replay</mat-icon>
                                </a> -->
                                <button mat-button mat-raised-button color="primary" class="vista-dialogbtn3" (click)="prevStep(); $event.preventDefault();" layout="row">
                                    Back
                                    <span flex></span>
                                    <mat-icon>replay</mat-icon>
                                </button>
                                <button mat-button mat-raised-button color="primary" class="vista-dialogbtn3" (click)="submit(); $event.preventDefault();" layout="row">
                                    Submit Quote
                                    <span flex></span>
                                    <mat-icon>done</mat-icon>
                                </button>
                                <!-- <a mat-button class="mat-primary mat-raised iwg-mat-raised"
                                    (click)="submit(); $event.preventDefault();" layout="row">
                                    Submit Quote
                                    <span flex></span>
                                    <mat-icon>done</mat-icon>
                                </a> -->
                            </div>
                        </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <div class="d-flex layout-column flex md-padding w-100" fxShow fxHide.lt-sm 
                    *ngIf="selectedStepIndex == 1 && quoteView.length != 0 && quoteView != null">

                    <div class="iwg-widget-box-card" *ngIf="Quote && ((selectedStepIndex + 1)===2)"
                        style="overflow-y: scroll;">
                        <table>
                            <tr>
                                <td colspan="3">
                                    <h3 class="bold">Review Markup Details</h3>
                                </td>
                            </tr>

                            <tr>
                                <td style="width:300px;">
                                    <label class="iwg-regular-label"><b><u>Generated Pricing</u></b></label><br />
                                </td>
                                <td style="width:50px;"></td>
                                <td style="width:500px;">
                                    <label class="iwg-regular-label"><b><u>Markup Override</u></b></label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    &nbsp;
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">Markup: </label><input
                                        [(ngModel)]="QuoteOverridenMarkupNew" type="number" step="0.25"
                                        name="QuoteOverridenMarkup"> <br />

                                    <button style="margin: 10px 0px 5px 5px;" mat-button mat-raised-button
                                        color="primary" class="mat-primary mat-raised iwg-mat-raised"
                                        (click)="calculateMarkupOverride()">
                                        Recalculate
                                    </button>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">Markup:
                                        {{QuoteMinimumMarkup * 100 | number: "1.2-2"}}%</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">Markup: {{QuoteOverridenMarkup}}%</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">Revenue:
                                        ${{QuoteMinimumRevenue | number: "1.2-2"}}</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">Revenue:
                                        ${{QuoteOverridenRevenue | number: "1.2-2"}}</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">Gross Profit:
                                        ${{QuoteMinimumGrossProfit | number: "1.2-2"}}</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">Gross Profit:
                                        ${{QuoteOverridenGrossProfit | number: "1.2-2"}}</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">Gross Profit %:
                                        {{(QuoteMinimumRevenue == 0)? 0 :100 * QuoteMinimumGrossProfit/QuoteMinimumRevenue | number: "1.2-2"}}%</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">Gross Profit %:
                                        {{(QuoteOverridenRevenue == 0)? 0 :100 * QuoteOverridenGrossProfit/QuoteOverridenRevenue | number: "1.2-2"}}%</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">1st Commission%:
                                        {{FormDataStep1.value.commission_percent  | number: "1.2-2"}}%</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">1st Commission%:
                                        {{FormDataStep1.value.commission_percent | number: "1.2-2"}}%</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">1st Commission:
                                        ${{QuoteMinimumSalesCommission | number: "1.2-2"}}</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">1st Commission:
                                        ${{QuoteOverridenSalesCommission | number: "1.2-2"}}</label><br />
                                </td>
                            </tr>


                            <tr>
                                <td>
                                    <label class="iwg-regular-label">2nd Commission%:
                                        {{FormDataStep1.value.commission_percent_secondary  | number: "1.2-2"}}%</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">2nd Commission%:
                                        {{FormDataStep1.value.commission_percent_secondary | number: "1.2-2"}}%</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">2nd Commission:
                                        ${{QuoteMinimumSalesCommissionSecondary | number: "1.2-2"}}</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">2nd Commission:
                                        ${{QuoteOverridenSalesCommissionSecondary | number: "1.2-2"}}</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">Net Income:
                                        ${{QuoteMinimumProfit | number: "1.2-2"}}</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">Net Income:
                                        ${{QuoteOverridenProfit | number: "1.2-2"}}</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label class="iwg-regular-label">Return on Sales:
                                        {{QuoteMinimumReturnOnSales * 100 | number: "1.2-2"}}%</label><br />
                                </td>
                                <td></td>
                                <td>
                                    <label class="iwg-regular-label">Return on Sales:
                                        {{QuoteOverridenReturnOnSales * 100 | number: "1.2-2"}}%</label><br />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <h3 class="bold">Review Quote Line Items</h3>
                                </td>
                            </tr>
                            <tbody *ngFor="let item of quoteView">
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label"><b><u>Entered</u></b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label"><b><u>Calculated</u></b></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">State: <b>{{item.State}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">Markup:
                                            {{item.Markup * 100 | number: "1.2-2" }}%</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Number Of Workers:
                                            <b>{{item?.NumberOfWorkers}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">Revenue:
                                            ${{item.Revenue | number: "1.2-2" }}</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">8810 Workers:
                                            <b>{{item.NumberOf8810}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">Gross Profit:
                                            ${{item.GrossProfit | number: "1.2-2" }}
                                            ({{(item.Revenue == 0) ?  0 : 100 * item.GrossProfit/item.Revenue | number: "1.2-2" }}%)</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">8810-Plus Workers:
                                            <b>{{item.NumberOf8810Plus}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">1st Commission:
                                            ${{item.SalesCommission | number: "1.2-2" }}
                                            ({{item.CommissionPercent * 100 | number: "1.2-2" }}%)</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Other Workers:
                                            <b>{{item.NumberOf8810Other}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">2nd Commission:
                                            ${{item.SalesCommissionSecondary | number: "1.2-2" }}
                                            ({{item.CommissionPercentSecondary * 100 | number: "1.2-2" }}%)</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Regular Workers:
                                            <b>{{item.NumberOfRegular}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">Net Income:
                                            ${{item.Profit | number: "1.2-2" }}</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Sporadic Workers:
                                            <b>{{item.NumberOfSporadic}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label"><label class="iwg-regular-label">Return on
                                                Sales: {{item.ReturnOnSales * 100 | number: "1.2-2" }}%</label></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Hours Per Week:
                                            <b>{{item.HoursPerWeek}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">SUTA:
                                            <b>{{item.SUTAPercent* 100 | number: "1.2-2" }}%</b></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Hourly Payrate:
                                            <b>${{item.HourlyPayrate | number: "1.2-2" }}/hr</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">FUTA:
                                            <b>{{item.FUTAPercent * 100| number: "1.2-2" }}%</b></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Start Date:
                                            <b>{{item.StartDate | date}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">FICA:
                                            <b>{{item.FICAPercent * 100| number: "1.2-2" }}%</b></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">End Date:
                                            <b>{{item.EndDate  | date}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">Medicare:
                                            <b>{{item.MedicarePercent * 100| number: "1.2-2" }}%</b></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="iwg-regular-label">Notes: <b>{{item.Notes}}</b></label>
                                    </td>
                                    <td></td>
                                    <td>
                                        <label class="iwg-regular-label">Validation: <b
                                                style="color:red">{{item.ValidationMessage}}</b></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <button style="margin-right: 10px;" mat-button mat-raised-button color="primary"
                                            class="mat-primary mat-raised iwg-mat-raised"
                                            (click)="editLineItem(item.ID,true)">
                                            Edit
                                        </button>
                                        <button mat-button mat-raised-button color="primary"
                                            class="mat-primary mat-raised iwg-mat-raised"
                                            (click)="deleteLineItem(item.ID,false)">
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <hr />
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                </div>

            </div>
        </div>
    </mat-dialog-content>
   
    <mat-dialog-actions align="end" class="justify-fend" style="overflow: auto;">

        <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-dialog-responsive"
         style="width: 100%;"
            [ngClass]="{'mobile-space-btn': ((selectedStepIndex == 1 && quoteView.length!==0))}">

            <div fxLayoutAlign="start center">
                <button mat-button (click)="prevStep()" [ngClass]="{'is-hidden': selectedStepIndex === 0?true:false}">«
                    Back</button>
            </div>

            <div fxLayout="row" fxLayoutAlign="end center">
                <button mat-button mat-dialog-close [ngClass]="{'is-hidden': selectedStepIndex === 4?true:false}">
                    <span *ngIf="selectedStepIndex == 0">Cancel</span>
                    <span *ngIf="selectedStepIndex != 0"><span class="mobile-hide">Save As</span>&nbsp;<span>Draft</span></span>
                </button>

                <button mat-button mat-raised-button color="primary" class="vista-dialogbtn" [disabled]="!canProceed()"
                    (click)="nextStep(false)" [ngClass]="{'is-hidden': selectedStepIndex != 1?true:false}">
                    Save Line Item 
                </button>
                <button mat-button class="vista-dialogbtn"
                    [disabled]="(canProceed() && selectedStepIndex == 1) ||  (!canProceed() && selectedStepIndex == 0) || (!LineItemsAdded && selectedStepIndex == 1)"
                    (click)="nextStep(true)" [ngClass]="{'is-hidden': selectedStepIndex == 2?true:false}" hide-xs>
                    <span class="mobile-hide">Save &</span>&nbsp;<span>Continue</span>
                </button>

              
                <button mat-button (click)="saveDraft()" [ngClass]="{'is-hidden': selectedStepIndex != 4?true:false}">
                    <span class="mobile-hide">Save as</span>&nbsp;<span>Draft</span>
                </button>

                <button mat-button class="mat-primary mat-raised iwg-mat-raised" (click)="submit()"
                    [ngClass]="{'is-hidden': selectedStepIndex != 4?true:false}">
                    Submit
                </button>
            </div>

        </div>
    </mat-dialog-actions>



</div>